import { useMemo } from 'react';

import { useSelector } from 'react-redux';
import { css } from 'styled-components';

import { selectPromoCodeError } from '../../slices/promoCode';

const errorStyle = css`
  margin-top: 3px;
  ${props => props.theme.errorInput.defaultStyle};
`;

const infoStyle = css`
  margin: 0;
  ${({ theme }) => css`
    ${theme.paragraph.variants.paragraph4.textStyles};
    color: ${theme.colors.grey};
  `}
`;

const inputPromoCodeStyle = (isError: boolean) => css<{
  showSuccess: boolean;
  isError: boolean;
}>`
  ${props => props.theme.input.defaultStyle};
  padding-right: 42px;
  padding-left: ${({ showSuccess }) => (showSuccess ? '35px' : '15px')};
  ${isError &&
  css`
    color: ${({ theme }) => theme.colors.red500};
  `}
`;

const labelPromoCodeStyle = css`
  color: ${props => props.theme.colors.gray500};

  &[data-label-position='floating'] {
    padding-left: 10px;
    line-height: 12px;
    font-size: 14px;
    transform: translate3d(0, 100%, 0);
  }

  &[data-label-position='inside'] {
    line-height: 16px;
    padding-left: 8px;
    font-size: 12px;
    transform: translate3d(0, 0, 0) scale(1);
  }
`;

const inputBoxStyle = css`
  padding: 4px 0 0;
  height: 50px;

  &[data-has-focus] {
    border-width: 1px;
    padding: 4px 0 0;
  }
`;

export function usePromoCodeInputSubtextStyling() {
  const error = useSelector(selectPromoCodeError);
  const isError = error !== null;
  return useMemo(
    () => ({
      subtextStyling: isError ? errorStyle : infoStyle,
      labelPromoCodeStyle,
      inputBoxStyle,
      inputPromoCodeStyle: inputPromoCodeStyle(isError),
    }),
    [isError]
  );
}
